export default __webpack_public_path__ + "static/56-c97812c49e6d5dd5b060c45ab6384183.gif";